// extracted by mini-css-extract-plugin
export default {"root":"FieldSwitch_root__3eNLw","selectError":"FieldSwitch_selectError__bzmnB"};